import { type ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

interface ProtectedRouteProps {
  children: ReactNode;
  fallback?: ReactNode;
}

export function ProtectedRoute({ children, fallback }: ProtectedRouteProps) {
  const { isAuthenticated, checkAuthStatus } = useAuth();

  // Check if authentication is disabled
  const isAuthDisabled = import.meta.env.VITE_DISABLE_AUTH === 'true';

  // If auth is disabled, always allow access
  if (isAuthDisabled) {
    return <>{children}</>;
  }

  // Check auth status on render - use checkAuthStatus() as the primary check
  // since it handles token expiry and returns the current authentication state
  const isCurrentlyAuthenticated = checkAuthStatus();

  if (isCurrentlyAuthenticated) {
    return <>{children}</>;
  }

  if (fallback) {
    return <>{fallback}</>;
  }

  // Only redirect to welcome when truly unauthenticated
  return <Navigate to="/welcome" replace />;
}